import Immutable from 'seamless-immutable';
import * as actionTypes from './actionTypes';

const initialState = Immutable({
  byId: {},
  params: {},
  actionsloading: false
});

export function financialinfoReducer(state = initialState, action) {
  // console.log('in financialinfo reduecer....', action)
  switch (action.type) {
    case actionTypes.FETCH_FINANCIALINFO:
      return {
        ...state,
        actionsloading: true
      }
    case actionTypes.FETCH_FINANCIALINFO_SUCCESS:
      return {
        ...state,
        byId: action.payload || {},
        actionsloading: false
      }
    default:
      return state;
  }
}